import "./SidePromotionSection.css";

const SidePromotionSection = () => null;

export default SidePromotionSection;
